<template>
  <div class="board-menu" ref="board-menu" v-loading="loading && taskList.length === 0">
    <vuedraggable class="move-box" ref="move-box" v-bind="subDragOptions('listId')" :list="taskList" @update="endListMove" handle=".task-drag-box">
      <div class="board-menu-item" v-for="(item, index) in taskList" :key="item.task_list_id">
        <div class="task-msgcount-super" v-if="item.msgCount > 0">{{ item.msgCount > 99 ? "99+" : item.msgCount }}</div>
        <div class="board-content-title">
          <div class="task-drag-box-f">
            <i class="icon iconfont iconicon_drag_order task-drag-box" v-if="isAdmin && !item.isTitleEdit && !isCheckStatus && !isDisabledProject"></i>
          </div>
          <div class="title-flex-box" v-if="!item.isTitleEdit">
            <div @click="editTitle(index,`inputs-${item.task_list_id}`)" class="title">
              <toolTip style="width: 100%" :title="item.title">
                <span class="title-txtpos">{{ item.title }}</span>
              </toolTip>
            </div>
          </div>
          <div v-else class="title-input">
            <el-input :ref="`inputs-${item.task_list_id}`" v-model="item.title" @blur="changeTitle(item)" @keyup.enter.native="enterTitleChange(`inputs-${item.task_list_id}`)"></el-input>
          </div>
          <div class="btns-handler">
            <el-dropdown class="dot-more" @command="handleCommandAddtask" size="small" trigger="click" v-if="isAdmin && !item.isTitleEdit && !isCheckStatus && !isDisabledProject" :class="{'visibleActive': item.moreShow}" @visible-change="changeListShow(item)">
              <el-tooltip class="item" effect="dark" content="更多选项" placement="top">
                <span class="task-sn-hover taskHoverIcon">
                  <i class="icon iconfont iconicon_more_task1"></i>
                </span>
              </el-tooltip>
              <el-dropdown-menu slot="dropdown" class="tasklist-title-more">
                <el-dropdown-item :command="{ type: 'delChecklist', item, index }" >
                  <i class="icon iconfont iconicon_recycle_bin"></i>
                  <span>移至回收站</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-tooltip class="item" effect="dark" content="添加任务" placement="top" v-if="!isCheckStatus && !isDisabledProject">
              <i class="icon iconfont iconicon_enlarge tableIconHover add-icon" @click="handleCommandAddtask({ type: 'addTask', item, index })"></i>
            </el-tooltip>
          </div>
        </div>
        <div class="board-content" ref="board-content" :data-list="item.task_list_id" :data-index="index" v-scroll-list v-loading="item.new_tasks_page.viewLoading">
          <div class="fo-header" v-sticky="{ zIndex: 991, stickyTop: 0}" @click="closeArchOrClose(item, 'unArchClose')">
            <el-tooltip class="fo-all-check" effect="dark" :content="item.unArchCheck ? '取消全选': '全选'" placement="top" v-if="isCheckStatus && item.all_tasks_count > 0 && !isDisabledProject">
              <el-checkbox class="fo-all-check--checkbox"  :indeterminate="item.unArchIndeterminate" :value="item.unArchCheck" @change="checkBoxChange(item, getKeyList(item.new_tasks), 'unArch')"></el-checkbox>
            </el-tooltip>
            <div class="textHover fo-header-text-content">
              <div class="up-arrow" >
                <i class="icon iconfont iconicon_drop_down_arrow" :class="{'rota90': !item.unArchClose}"></i>
              </div>
              <p class="fo-header-text">未归档父任务</p>
              <p><span>{{item.finish_tasks_count}}</span>/<span>{{item.all_tasks_count}}</span></p>
            </div>
            <div class="task-badge-head" v-if="item.unArchClose && hasMsg(getKeyList(item.new_tasks))"></div>
          </div>
          <el-collapse-transition>
            <div class="task-move-box" :ref="'board_'+ item.task_list_id + '_tasks'" v-if="!item.unArchClose">
              <vuedraggable class="task-item-move" :class="{'task-item-move-top': val && val.length === 0}" :style="{'z-index': moveKey === key ? 999 : 0}" v-for="(val, key) in item.new_tasks" :key="key" v-bind="subDragOptions(key)" :list="val || []" @add="end" @update="end" :data-key="key" :data-list="item.task_list_id" @start="start(key)">
                <div v-for="temp in val" :key="temp.id" data-list="list.task_list_id" :data-id="temp.id" :data-rule="temp.sort_rule_id">
                  <Item :dataset="temp" @handleCommand="handleCommand" type="unArch" @click.native="editTask(temp.task_list_id, temp.id, key, temp, item, getKeyList(item.new_tasks), 'unArch')" :index="index" @changeCheck="initLoadList"></Item>
                </div>
              </vuedraggable>
              <wf-button class="add-task" icon="icon iconfont iconicon_enlarge" auto card @click="addTask(item)" v-if="!isCheckStatus && !isDisabledProject"></wf-button>
              <div class="loading-box" v-if="item.new_tasks_page.loading">
                <i class="el-icon-loading"></i>
                <span>载入中...</span>
              </div>
            </div>
          </el-collapse-transition>
          <div class="fo-header" style="padding-top: 24px;" v-sticky="{ zIndex: 100, stickyTop: 26}" @click="closeArchOrClose(item, 'archClose')">
            <el-tooltip class="fo-all-check"  effect="dark" :content="item.archCheck ? '取消全选': '全选'" placement="top" v-if="isCheckStatus && item.all_archived_tasks_count > 0 && !isDisabledProject">
              <el-checkbox class="fo-all-check--checkbox" :indeterminate="item.archIndeterminate" :value="item.archCheck" @change="checkBoxChange(item, item.archived_tasks, 'arch')"></el-checkbox>
            </el-tooltip>
            <div class="textHover fo-header-text-content">
              <div class="up-arrow" >
                <i class="icon iconfont iconicon_drop_down_arrow" :class="{'rota90': !item.archClose}"></i>
              </div>
              <p class="fo-header-text">已归档父任务</p>
              <p><span>{{item.all_archived_tasks_count}}</span></p>
            </div>
            <div class="task-badge-head" v-if="item.archClose && hasMsg(item.archived_tasks)"></div>
          </div>
          <div :ref="'board_'+ item.task_list_id + '_arch'" :style="{'display': item.archClose ? 'none': 'block'}">
            <div class="task-item-move" v-for="(temp, key) in item.archived_tasks" :key="key" >
              <Item :dataset="temp" @handleCommand="handleCommand" type="arch" @click.native="editTask(temp.task_list_id, temp.id, key, temp, item, item.archived_tasks,'arch')" :index="index" ></Item>
            </div>
            <div class="loading-box" v-if="item.arch_page.loading">
              <i class="el-icon-loading"></i>
              <span>载入中...</span>
            </div>
          </div>
        </div>
      </div>
    </vuedraggable>
    <div class="board-menu-item board-content---addlist" v-if="finish && isAdmin && taskList.length > 0 && !isCheckStatus && !isDisabledProject">
      <div @click="addChecklist" class="add-btn">
        <span class="btnHover"><i class="icon iconfont iconicon_new_subproject"></i>添加任务清单</span>
      </div>
    </div>
    <div class="line-loading" v-if="!finish" :style="{ visibility: loading ? 'visible' : 'hidden' }">
      <i class="el-icon-loading"></i>
    </div>
    <nothing v-else-if="!loading && taskList.length == 0" :config="{ tip: '暂无任务清单', btnText: isAdmin && !isDisabledProject ? '新建任务清单' : '', type: 'img_no_data' }" @button-click="addChecklist"></nothing>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import Bit from "@/components/bit";
import bus from "@/bus";
import api from "@/services/api/task/task";
import vuedraggable from "vuedraggable";
import followApi from "@/services/api/follow/follow";
import Item from './item'
import VueSticky from 'vue-sticky';
export default {
  props: {
    projectId: String,
  },
  components: {
    Bit,
    vuedraggable,
    Item
  },
  data() {
    return {
      isEdit: false,
      inputTitle: '',
      loading: false,
      finish: false,
      taskList: [],
      listPage: {
        page: 1,
        number: 10,
        task_number: 10,
      },
      taskListNumber: 10,
      objectKey: '',
      isDisabled: true,
      nowTaskListId: '',
      nowTaskListIndex: '',
      taskDetailKey: '',
      inputTitle: '',
      isFirstComing: false,
      timer: null,
      moveKey: '',
    };
  },
  computed: {
    ...mapState("project/project", ["isAdmin"]),
    ...mapState('task/task', {
      queryMsg: state => state.queryMsg,
      isCheckStatus: state => state.isCheckStatus,
      isDisabledProject: state => state.isDisabledProject
    }),
    hasMsg() {
      return (item) => {
        return item.some(res => res.unread_message_count > 0)
      };
    },
    getKeyList() {
      return (list) => {
        let item = [];
        for (let key in list) {
          if (typeof(list[key]) === 'object' && list[key] && list[key].length > 0) {
            item.push(...list[key]);
          }
        }
        return item;
      };
    },
  },
  watch: {
    taskList: {
      handler() {
        if (this.taskList.length > 0) {
          this.isDisabled = false;
        }
      },
      deep: true,
    },
    projectId() {
      this.restData();
    },
  },
  beforeDestroy() {
    bus.$off("updateList");
    bus.$off("sendMessageReal");
    bus.$off("sendMessageRealOne");
    bus.$off("updateTask");
  },
  created() { },
  mounted() {
    this.init();
    this.setBus();
    // queryMsg: {
    //   handler() {
    //     this.debounce(this.restData, 300)
    //   },
    //   deep: true,
    //   immediate: true
    // }
    setTimeout(() => {
      this.$watch(() => this.queryMsg, () => {
        this.debounce(this.restData, 300)
      }, {deep: true})
    }, 1000)
  },
  directives: {
    'scroll-list': {
      inserted(el, binding, vnode) {
        let _this = vnode.context
        const scrollHandler = () => {
          const scrollTop = el.scrollTop + el.clientHeight;
          _this.nowTaskListId = el.dataset.list
          _this.nowTaskListIndex = el.dataset.index
          let ref_tasks = 'board_'+ el.dataset.list + '_tasks'
          let ref_arch = 'board_' + el.dataset.list + '_arch'
          let list1 = _this.$refs[ref_tasks][0]
          let list2 = _this.$refs[ref_arch][0]
          if (scrollTop > (list1.offsetHeight - 50) && _this.taskList[_this.nowTaskListIndex].new_tasks_page && !_this.taskList[_this.nowTaskListIndex].new_tasks_page.loading) {
            _this.loadList()
          }
          if (scrollTop > (list1.offsetHeight + list2.offsetHeight - 50 && _this.taskList[_this.nowTaskListIndex].arch_page && !_this.taskList[_this.nowTaskListIndex].arch_page.loading)) {
            _this.loadListArch()
          }
        }
        el.addEventListener('scroll', scrollHandler);
      }
    },
    'sticky': VueSticky,
  },
  methods: {
    ...mapActions("task/task", ["editChecklist", "deletetasklist", "delTask", "archivedTask", "updateStatus", "updateorderby",'getTaskListTable']),
    ...mapMutations('task/task', ['set_checkTask']),
    init() {
      console.log('initttttttttttt')
      this.restData();
      // this.getTaskInListUp()
    },
    setBus() {
      bus.$on("updateTask", (data) => {
        if(!data || data.isNeedReset) {
        this.restData();
      } else {
        this.updateTask(data)
      }
      });
      bus.$on("updateList", (task_list_id, task_id) => {
        this.taskList.find((res, index) => {
          if (res.task_list_id == task_list_id) {
            res.new_tasks[this.taskDetailKey].find((item, idx) => {
              if (item.id == task_id) {
                this.taskList[index].new_tasks[this.taskDetailKey].splice(idx, 1);
                return true;
              }
            });
            return true;
          }
        });
      });
      bus.$on("sendMessageReal", () => {
        this.init();
      });
      bus.$on("sendMessageRealOne", ({ task_list_id, task_id }) => {
        this.init();
      });
      bus.$on('clear_check', () => {
        console.log('clear_check')
        this.taskList.map(res => {
          this.$set(res, 'unArchCheck', false)
          this.$set(res, 'unArchIndeterminate', false)
          this.$set(res, 'archCheck', false)
          this.$set(res, 'archIndeterminate', false)
        })
      })
    },
    async updateTask(data) {
      let { task_id, task_list_id } = data
      let result = await api.getTaskDetail({ task_id })
      let arr = this.taskList.find(res => res.task_list_id === task_list_id)
      if(!arr) return
      if(result.task_stage === '已归档') {
        let idx = arr.archived_tasks.findIndex(res => res.id === task_id)
        idx > -1 ? arr.archived_tasks.splice(idx, 1, { ...arr.archived_tasks[idx], ...result }) : ''
      } else {
        for(let key in arr.new_tasks) {
          if (typeof(arr.new_tasks[key]) === 'object' && arr.new_tasks[key] && arr.new_tasks[key].length > 0) {
            for (let i = 0; i < arr.new_tasks[key].length; i++) {
              if (arr.new_tasks[key][i].id == task_id) {
                arr.new_tasks[key].splice(i, 1, { ...arr.new_tasks[key][i], ...result })
                return
              }
            }
          }
        }
      }
    },
    editTitle(index, ref) {
      if (!this.isAdmin) {
        return;
      }
      this.taskList[index].isTitleEdit = true;
      this.inputTitle = this.taskList[index].title;
      this.$nextTick(() => {
        this.$refs[ref][0].focus()
      })
    },
    async changeTitle(item) {
      try {
        await this.editChecklist({
          task_list_id: item.task_list_id,
          title: item.title,
        })
      } catch (error) {
      }
      item.isTitleEdit = false;
    },
    enterTitleChange(ref) {
      this.$refs[ref][0].blur()
    },
    cancelBtn(item) {
      item.title = this.inputTitle;
      item.isTitleEdit = false;
    },
    handleCommandAddtask(command) {
      if (command.type === "addTask") {
        bus.$emit('addTask', {task_list_id: command.item.task_list_id, id:0})
      }
      if (command.type === "delChecklist") {
        this.delChecklist(command.item, command.index);
      }
    },
    delChecklist(data, index) {
      this.deletetasklist({
        task_list_id: data.task_list_id,
      })
        .then((res) => {
          this.taskList.splice(index, 1);
        })
        .catch(() => {});
    },
    getTaskList({ page, number = this.taskListNumber, task_list_id, is_load_archived_tasks }) {
      let params = {
        page,
        number: number,
        ...this.queryMsg,
        is_load_archived_tasks: is_load_archived_tasks || 0,
        task_list_id,
      }
      return api.getNumberTaskList(params);
    },
    async getTaskInListUp() {
      this.loading = true;
      let result = await api.getProjectTaskList({ ...this.listPage, project_id: this.projectId,...this.queryMsg })
      if (result.data.length === 0) {
        this.finish = true;
        this.loading = false;
        return;
      }
      result.data.forEach((item) => {
        item.new_tasks_page = {
          page: 1,
          loading: false,
          finish: item.new_tasks && item.new_tasks.length === 0, // 是否在一进来就没有数据
        }
        item.arch_page = {
          page: 1,
          loading: false,
          finish: item.archived_tasks && item.archived_tasks.length === 0, // 是否在一进来就没有数据
        }
        item.new_tasks = JSON.parse(JSON.stringify(this.groupToArrayByValue(item).result));
      })
      console.log('-------------pppp------------', JSON.parse(JSON.stringify(this.taskList)), JSON.parse(JSON.stringify(result.data)))
      this.taskList.push(...result.data);
      this.loading = false;
      this.$nextTick(() => {
        this.getNeedPush();
      });
    },
    getNeedPush() {
      if(!this.$refs["move-box"] || !this.$refs["board-menu"]) return
      let box = this.$refs["board-menu"] ? this.$refs["board-menu"].offsetWidth : 0
      let inBox = this.$refs["move-box"].$el.offsetWidth
      if (box > inBox && !this.finish && !this.loading) {
        this.taskListLoading();
      }
    },
    groupToArrayByValue(arrData) {
      let result = {
        level4: [],
        level3: [],
        level2: [],
        level1: [],
        compete: []
      };
      let count = 0;
      arrData.isTitleEdit = false;
      arrData.new_tasks.forEach((item) => {
        result.isTitleEdit = false;
        if(item.task_stage === '已完成') {
          result.compete.push(item)
        } else {
          result["level" + item.sort_rule.sort] ? result["level" + item.sort_rule.sort].push(item) : (result["level" + item.sort_rule.sort] = [item]);
        }
      });
      return { result, count };
    },

    handleCommand(comm) {
      this.nowTaskListId = comm.dataset.task_list_id
      this.nowTaskListIndex = this.taskList.findIndex(res => res.task_list_id === comm.dataset.task_list_id)
      switch (comm.type) {
        case 'del':
          this.deletetask(comm.dataset);
          break
        case 'edit':
          this.$emit("taskClick", { task_list_id: comm.dataset.task_list_id, task_id: comm.dataset.id });
          break
        case 'archive':
          this.archiveTask(comm.dataset);
          break
        case 'follow':
          followApi.subscriptionTask({ task_id: comm.dataset.id }).then((res) => {
            this.addSuccess(comm.dataset.task_list_id);
          });
          break
        case 'unFollow':
          followApi.unsubscribeTask({ task_id: comm.dataset.id }).then((res) => {
            this.addSuccess(comm.dataset.task_list_id);
          });
          break
        case 'unarchive':
          this.unarchiveTask(comm.dataset)
          break
        default:
          break
      }
    },
    async deletetask(temp) {
      await this.$wfAlert('warning', '确认删除任务吗？', '删除后的任务，将不再出现在工作台，你可以在回收站中对该任务进行恢复。', '移到回收站')
      await this.delTask({ task_id: temp.id })
      this.$message({
        type: "success",
        message: "删除成功!",
      });
      this.addSuccess(temp.task_list_id);
    },
    async archiveTask(temp) {
      await this.$wfAlert('warning', '确认归档此任务？', '归档后的任务,将不可再编辑。你可以重新激活将任务恢复，进行编辑。', '确定')
      await this.updateStatus({ task_id: temp.id, task_stage: "已归档" })
      this.$message({
        type: "success",
        message: "归档成功",
      });
      this.addSuccess(temp.task_list_id);
    },
    async unarchiveTask(temp) {
      await this.$wfAlert('warning', '确认恢复未归档该任务吗？', '恢复未归档该项目后，任务将恢复到未归档状态，可进行编辑。', '确定')
      await this.updateStatus({ task_id: temp.id, task_stage: "进行中" })
      this.$message({
        type: "success",
        message: "设置任务未归档成功",
      });
      this.addSuccess(temp.task_list_id);
    },

    subDragOptions(key) {
      return {
        animation: 200,
        group: key,
        disabled: !this.isAdmin || key === "compete",
      };
    },
    end(event) {
      // 在数据集合中去获取值信息
      console.log(event)
      let from_id = event.from.dataset.list
      let to_id = event.to.dataset.list
      let task_list_id = ""
      let previous_task_id = ""
      let task_id = event.item.dataset.id * 1
      let key = event.from.dataset.key;
      if (from_id !== to_id) {
        let dataset = this.taskList.find((res) => res.task_list_id == to_id)
        let fDataset = this.taskList.find((res) => res.task_list_id == from_id)
        previous_task_id = event.newIndex - 1 < 0 ? 0 : dataset.new_tasks[key][event.newIndex - 1].id
        task_list_id = to_id;
        dataset.all_tasks_count = dataset.all_tasks_count + 1
        fDataset.all_tasks_count = fDataset.all_tasks_count - 1

      } else {
        let dataset = this.taskList.find((res) => res.task_list_id == from_id);
        previous_task_id = event.newIndex - 1 < 0 ? 0 : dataset.new_tasks[key][event.newIndex - 1].id
      }
      let params = {
        task_id,
        previous_task_id,
      };
      task_list_id ? (params.task_list_id = task_list_id) : ""
      api.updateTaskSort(params).then((res) => {
        this.$message({
          message: "修改成功",
          type: "success",
        });
      });
    },
    endListMove(e) {
      let temp = this.taskList.map((item, index) => {
        return {
          task_list_id: item.task_list_id,
          orderby: index,
        };
      });
      this.updateorderby({ project_id: this.projectId, list: temp }).then((res) => {
        this.$message({
          message: "修改成功",
          type: "success",
        });
      });
    },
    async addSuccess(id) {
      let index = this.taskList.findIndex(res => res.task_list_id === id)
      this.initLoadList(index)
      this.initLoadListArch(index)
    },
    editTask(task_list_id, task_id, key, temp, item, dataset, type) {
      if(this.isCheckStatus) {
        this.set_checkTask(task_id)
        this.$nextTick(() => {
          if(!dataset || dataset.length === 0) return
          if(dataset.every(res => res.check)) {
            this.$set(item, `${type}Indeterminate`, false)
            this.$set(item, `${type}Check`, true)
          } else if(dataset.some(res => res.check)) {
            this.$set(item, `${type}Check`, false)
            this.$set(item, `${type}Indeterminate`, true)
          } else {
            this.$set(item, `${type}Check`, false)
            this.$set(item, `${type}Indeterminate`, false)
          }
          console.log(item)
        })
        return
      }
      temp.unread_message_count = 0;
      this.taskDetailKey = key;
      this.$emit("taskClick", { task_list_id, task_id });
    },
    addTask(item) {
      bus.$emit('addTask', {task_list_id: item.task_list_id, id:0})
    },
    async restData() {
      console.log('--------dddd-------')
      this.taskList = [];
      this.loading = false;
      this.finish = false;
      this.listPage.page = 1;
      await this.getTaskListTable({project_id: this.projectId})
      await this.getTaskInListUp();
    },
    async initLoadList(index) {
      this.nowTaskListIndex = index
      this.nowTaskListId = this.taskList[index].task_list_id
      this.taskList[index].new_tasks_page = {
        page: 1,
        loading: false,
        finish: false,
        viewLoading: true
      }
      let result = await this.getTaskList({
        page: this.taskList[index].new_tasks_page.page,
        task_list_id: this.taskList[index].task_list_id
      })
      this.taskList[index].new_tasks = []
      // this.taskList[index].new_tasks = JSON.parse(JSON.stringify(this.groupToArrayByValue(this.taskList[index]).result))
      // await this.loadList()
      this.$nextTick(() => {
        this.taskList[index].finish = result.new_tasks && result.new_tasks.length === 0
        this.taskList[index].new_tasks = JSON.parse(JSON.stringify(this.groupToArrayByValue(result).result))
        this.taskList[index].new_tasks_page.viewLoading = false
      })
    },
    async initLoadListArch(index) {
      this.taskList[index].arch_page = {
        page: 1,
        loading: true,
        finish: false
      }
      let result = await this.getTaskList({
        page: this.taskList[index].arch_page.page,
        task_list_id: this.taskList[index].task_list_id,
        is_load_archived_tasks: 1
      })
      this.taskList[index].archived_tasks = []
      // await this.loadListArch()
      this.$nextTick(() => {
        this.taskList[index].archived_tasks = result.archived_tasks
        this.taskList[index].arch_page.loading = false
        this.taskList[index].arch_page.finish = result.archived_tasks && result.archived_tasks.length === 0
      })
    },
    loadList(e) {
      if (this.nowTaskListIndex === '' || this.taskList.length === 0 || this.taskList[this.nowTaskListIndex].new_tasks_page.loading || this.taskList[this.nowTaskListIndex].new_tasks_page.finish) {
        return;
      }
      this.taskList[this.nowTaskListIndex].new_tasks_page.loading = true;
      this.taskList[this.nowTaskListIndex].new_tasks_page.page = this.taskList[this.nowTaskListIndex].new_tasks_page.page + 1;
      return this.getTaskList({ page: this.taskList[this.nowTaskListIndex].new_tasks_page.page, task_list_id: this.nowTaskListId }).then((res) => {
        this.taskList[this.nowTaskListIndex].finish_tasks_count = res.finish_tasks_count
        this.taskList[this.nowTaskListIndex].all_tasks_count = res.all_tasks_count
        if (res.new_tasks.length === 0) { // 已加载完成
          this.taskList[this.nowTaskListIndex].new_tasks_page.finish = true;
        } else { // 正常加载数据
          let task = this.groupToArrayByValue(res);
          for (let key in this.taskList[this.nowTaskListIndex].new_tasks) {
            if (typeof task.result[key] !== "boolean" && task.result[key]) {
              this.taskList[this.nowTaskListIndex].new_tasks[key].push(...task.result[key]);
            }
          }
        }
        this.taskList[this.nowTaskListIndex].new_tasks_page.loading = false;
      });
    },
    loadListArch() {
      if (this.nowTaskListIndex === '' || this.taskList.length === 0 || this.taskList[this.nowTaskListIndex].arch_page.loading || this.taskList[this.nowTaskListIndex].arch_page.finish) {
        return;
      }
      this.taskList[this.nowTaskListIndex].arch_page.loading = true;
      this.taskList[this.nowTaskListIndex].arch_page.page = this.taskList[this.nowTaskListIndex].arch_page.page + 1;
      return this.getTaskList({ page: this.taskList[this.nowTaskListIndex].arch_page.page, task_list_id: this.nowTaskListId, is_load_archived_tasks: 1 }).then((res) => {
        this.taskList[this.nowTaskListIndex].arch_page.loading = false;
        if (res.archived_tasks.length === 0) {
          this.taskList[this.nowTaskListIndex].arch_page.finish = true;
        } else {
          this.taskList[this.nowTaskListIndex].archived_tasks.push(...res.archived_tasks)
        }
      });
    },
    taskListLoading() {
      if(this.finish || this.loading) return
      console.log('-----------loading-------')
      this.loading = true;
      this.listPage.page = this.listPage.page + 1;
      this.getTaskInListUp();
    },
    addChecklist() {
      this.$emit("addTaskList");
    },
    closeArchOrClose(val, key) {
      this.$set(val, key, !val[key])
    },
    changeListShow(item) {
      this.$set(item, 'moreShow', !item.moreShow)
    },
    //防抖函数
    debounce(fn, wait) {
      console.log('--------dddd222-------', this.timer)
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(fn, wait)
    },
    checkBoxChange(item, list, type) {
      if(item[`${type}Check`]) { // 取消全选
        list.forEach(res => {
          if(res.check) {
            this.set_checkTask(res.id)
          }
        })
        this.$set(item, `${type}Indeterminate`, false)
        this.$set(item, `${type}Check`, false)
      } else { // 全选
        list.forEach(res => {
          if(!res.check) {
            this.set_checkTask(res.id)
          }
        })
        this.$set(item, `${type}Indeterminate`, false)
        this.$set(item, `${type}Check`, true)
      }
    },
    start(key) {
      console.log('-----asd-----', key)
      this.moveKey = key
    }
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/mixin.scss";
.fo-all-check--checkbox {
  .el-checkbox__inner {
    background-color: #fff;
    border:1px solid rgba(32, 32, 32, 0.60);
  }
}
.board-menu {
  height: 100%;
  display: flex;
  width: 100%;
  // overflow-y: hidden;
  box-sizing: border-box;
  position: relative;
  background-color: rgba(247, 247, 247, 1);
  .task-level {
    margin-right: 16px;
  }
  .board-start {
    margin-right: 16px;
    background-color: rgba(246, 212, 117, 0.24);
    border-radius: 2px;
    width: 18px;
    height: 18px;
    text-align: center;
    line-height: 18px;
    i {
      font-size: 14px;
    }
  }
  .move-box {
    height: 100%;
    display: flex;
  }
  .title {
    max-width: 176px;
    cursor: pointer;
  }
  &::after {
    content: "";
    display: block;
    width: 1px;
    height: 100%;
    flex-shrink: 0;
  }
  .task-drag-box-f {
    width: 17px;
    display: flex;
    align-items: center;
  }
  .task-drag-box {
    font-size: 12px;
    color: #959ca9;
    visibility: hidden;
    margin-left: 4px;
    cursor: pointer;
    &:hover {
      color: #2682ff;
    }
  }
  .title-flex-box {
    font-size: 16px;
    display: flex;
    align-items: flex-end;
    font-weight: 400;
    flex: 1;
  }
  .dot-more {
    margin: 0 6px;
  }
  .board-menu-item:first-child {
    // margin-left: 16px;
  }
  .board-menu-item {
    position: relative;
    // margin: 9px 8px 16px 0;
    // border-radius: 5px;
    width: 288px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    // padding-bottom: 5px;
    border-right: 1px solid rgba(13, 37, 60, 0.08);
    background-color: #F7F7F7;
    &:hover {
      .task-drag-box {
        visibility: visible;
      }
      .btns-handler .dot-more {
        visibility: visible;
      }
    }
    .el-loading-mask {
      background-color: #F7F7F7;
    }
  }
  .finish_num {
    color: rgba(25, 24, 67, 0.6);
  }
  .total_num,
  .slash {
    color: rgba(32, 32, 32, 0.4);
  }
  .task-total {
    font-size: 12px;
    margin-left: 8px;
    font-weight: normal;
  }
  .board-content-title {
    display: flex;
    height: 72px;
    align-items: center;
    padding-right: 12px;
    .btns-handler {
      display: flex;
      align-items: center;
      i {
        font-size: 14px;
        @include fontColorOpacity(.6);
      }
      .dot-more {
        visibility: hidden;
      }
    }
  }
  .board-content {
    height: 100%;
    overflow: auto;
    overflow: overlay;
    position: initial !important;
    &::-webkit-scrollbar-thumb {
      background-color: transparent;
    }
    .fo-header {
      display: flex;
      align-items: center;
      font-size: 14px;
      padding: 0 16px;
      padding-bottom: 8px;
      background-color: rgba(247, 247, 247, 1);
      line-height: 1.3;
      .fo-all-check {
        margin-right: 8px;
      }
      .fo-header-text {
        padding-left: 6px;
        padding-right: 8px;
      }
      i {
         font-size: 12px;
         @include fontColorOpacity(.24);
      }
      .task-badge-head {
        width: 8px;
        height: 8px;
        background: linear-gradient(227deg, #7aa7e2 0%, #456fb3 100%);
        border-radius: 50%;
        position: absolute;
        right: 20px;
        bottom: 12px;
      }
      .fo-header-text-content {
        display: flex;
        align-items: center;
        .up-arrow {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          i {
            transition: all .3s;
          }
        }
      }

    }
  }
  .board-content-td {
    position: relative;
    width: 256px;
    max-height: 126px;
    margin: 0 auto 8px auto;
    flex-shrink: 0;
    background-color: #fff;
    border-radius: 4px;
    box-sizing: border-box;
    cursor: pointer;
    box-shadow: 0px 2px 4px 0px rgba(32,32,32,0.08);
    .task-create-date .task-left-item {
      margin-top: 18px;
    }
    .task-flex-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      .task-left {
        display: flex;
        align-items: center;
      }
      .task-left-item {
        display: flex;
        align-items: center;
        font-size: 12px;
        margin-right: 17px;
        color: rgba(32, 32, 32, 0.6);
        i {
          font-size: 12px;
          margin-right: 6px;
        }
      }
    }
    .task-date {
      font-size: 13px;
      color: rgba(32,32,32,0.8);
      border-radius: 2px;
      margin-right: 16px;
    }
    .task-title-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 16px;
      max-width: 100%;
      padding-right: 2px;
      font-weight: 500;
      line-height: 1.3;
      height: 28px;
      > div {
        flex-shrink: 0;
      }
    }
    .task-title-wrap-item {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      max-width: 74%;
      align-items: center;
      .task-check {
        display: flex;
        align-items: center;
        margin-right: 8px;
        flex-shrink: 0;
      }
    }
    &:before {
      content: "";
      width: 3px;
      height: 100%;
      position: absolute;
      background-color: rgba(255, 255, 255, 0);
      border-radius: 50px 0 0 50px;
      top: 0;
      left: 0;
      bottom: 0;
    }
    &:hover {
      .task-sn {
        visibility: visible;
      }
    }
  }
  .board-content---addlist {
    display: flex;
    .add-btn {
      font-size: 14px;
      color: rgba(32, 32, 32, 0.6);
      margin-top: 25px;
      margin-left: 10px;
      i {
        font-size: 14px;
        margin-right: 6px;
        color: rgba(32, 32, 32, 0.6);
      }
      span {
        padding: 4px 6px;
      }
    }
  }
  .board-top {
    flex: 1;
    padding: 14px 11px 13px 13px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .remind {
    .task-date {
      color: #ff8b23 !important;
    }
    &:before {
      background-color: #ff8b23 !important;
    }
  }
  .expired {
    .task-date {
      color: #ff3939 !important;
    }
    &:before {
      background-color: #ff3939 !important;
    }
  }
  .board-bottom {
    border-top: 1px solid #f8f9fb;
    height: 40px;
    line-height: 40px;
    padding-right: 14px;
    margin-left: 14px;
    .task-principal {
      font-size: 14px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 100%;
    }
    .task-principal .avatar-wrap {
      display: flex;
      align-items: center;
    }
    .task-principal .avatar-wrap .task-avatar {
      width: 26px;
      height: 26px;
      margin-right: 12px;
    }
    .task-sn {
      height: 16px;
      line-height: 16px;
      text-align: center;
      border-radius: 2px;
      font-size: 12px;
      color: rgba(25, 24, 67, 0.6);
      align-items: center;
      display: flex;
      visibility: hidden;
      .task-sn-nore {
        margin-left: 8px;
      }
    }
  }
  .task-sn-hover {
    display: block;
    text-align: center;
    cursor: pointer;
  }
  .task-sub-info {
    display: flex;
    align-items: center;
    font-size: 12px;
    line-height: 1;
  }
  .task-sub-info > i {
    font-size: 12px;
    margin-right: 7px;
  }
  .complete , .complete-task{
    * {
      color: rgba(32, 32, 32, 0.4) !important;
      opacity: 1;
      i {
        color: rgba(32, 32, 32, 0.4)  !important;
      }
    }
    .avatar-box {
      opacity: 0.4;
    }
    .task-level {
      color: rgba(32, 32, 32, 0.4) !important;
      background: rgba(32, 32, 32, 0.08) !important;
    }
    .task-sn i{
      color: initial !important;
    }
    .board-start {
      background-color: rgba(32, 32, 32, 0.08);
    }
  }
  .complete.board-content-td {
    background: #E1E0E0 !important;
    box-shadow: none;
    .board-bottom {
      border-color: rgba(13, 31, 60, 0.04);
    }
  }
  .add-task {
    width: 256px;
    margin: 0 auto;
    position: relative;
    z-index: 101;
  }
  .task-item-move {
    min-height: 2px;
    flex-shrink: 0;
  }
  .task-move-box {
    position: relative;
  }
  .task-item-move-top {
    margin-top: -2px;
    position: relative;
  }
  .loading-box {
    font-size: 14px;
    text-align: center;
    color: #999;
    height: 30px;
    line-height: 30px;
    i {
      margin-right: 5px;
    }
  }
  .line-loading {
    height: 100%;
    margin-left: -10px;
    font-size: 20px;
    width: 30px;
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .task-badge {
    position: absolute;
    right: -1px;
    top: -1px;
    width: 8px;
    height: 8px;
    background: linear-gradient(227deg, #7aa7e2 0%, #456fb3 100%);
    border-radius: 50%;
    z-index: 999;
  }
  .title-input {
    display: flex;
    align-items: center;
    width: 0;
    flex: 1;
    .wf-button {
      flex-shrink: 0;
    }
  }
}

</style>
